<template>
  <div>
    <Head title="Reportes" />
    <h1 class="mb-8 text-3xl font-bold">Reportes</h1>

    <div class="bg-white p-5 mb-2">
      <h1 class="mb-8 text-xl font-bold">Reportes diarios</h1>
      <div class="m-2 flex">
        <a target="_blank" href="/ordersDaily" class="btn-blue">Reporte de venta</a>
        <a target="_blank" href="/orders/pay/reportDaily" class="btn-blue ml-2">Relación de pagos</a>
        <a target="_blank" href="/orders/pay/reportDailyAdvance" class="btn-blue ml-2">Relación de pagos detallados</a>
      </div>
    </div>

    <div class="bg-white p-5 mb-2">
      <h1 class="mb-8 text-xl font-bold">Inventario por deposito</h1>
      <div v-for="deposit in deposits" :key="deposit.key" class="m-2 flex">
        <a target="_blank" :href="`/products/${deposit.id}/deposits`" class="btn-blue">{{deposit.name}}</a>
      </div>
    </div>
    <div class="bg-white p-5">
      <div class="flex">
        <text-input v-model="form.from" label="Desde" class="pb-8 pr-6 w-full lg:w-1/2" type="date" />
      <text-input v-model="form.to" label="Hasta" class="pb-8 pr-6 w-full lg:w-1/2" type="date" />
      <!-- <select-input v-model="form.type" label="Vendedor" class="pb-8 pr-6 w-full lg:w-1/2">
        <option value="">Seleccionar</option>
        <option v-for="vendor in vendors" :key="vendor.id" :value="vendor.id">
          {{vendor.name}}
        </option>
      </select-input>
      <select-input v-model="form.type" label="Cliente" class="pb-8 pr-6 w-full lg:w-1/2">
        <option value="">Seleccionar</option>
        <option v-for="client in clients" :key="client.id" :value="client.id">
          {{client.companyName}}
        </option>
      </select-input> -->
      <select-input v-model="form.modality" label="Modalidad" class="pb-8 pr-6 w-full lg:w-1/2">
        <option value="">Seleccionar</option>
<!--        <option value="pdf">PDF</option>-->
        <option value="credit">Credito</option>
        <option value="no-credit">De contado</option>
      </select-input>
      </div>
    </div>

    <div class="bg-white p-5 mb-2">
      <h1 class="mb-8 text-xl font-bold">Ventas</h1>
      <div class="m-2 flex">
        <a :href="`/reports/sales/totals/${form.from}/${form.to}/${form.modality}`" target="_blank" class="btn-blue mr-2">Totales</a>
        <a :href="`/reports/sales/returns/${form.from}/${form.to}`" target="_blank" class="btn-blue mr-2">Devoluciones</a>
        <a :href="`/reports/sales/byVendor/${form.from}/${form.to}`" target="_blank" class="btn-blue mr-2">Ventas por vendedor</a>
        <a :href="`/reports/sales/byClients/${form.from}/${form.to}`" target="_blank" class="btn-blue mr-2">Ventas por cliente</a>
      </div>
    </div>

    <!-- <div class="bg-white p-5 mb-2">
      <h1 class="mb-8 text-xl font-bold">Clientes</h1>
      <div class="m-2 flex">
        <a target="_blank" :href="`#`" class="btn-blue mr-2">Deudas de clientes</a>
        <a target="_blank" :href="`#`" class="btn-blue mr-2">Compras de clientes</a>
        <a target="_blank" :href="`#`" class="btn-blue mr-2">Top de Clientes con más compras</a>
      </div>
    </div> -->

    <!-- <div class="bg-white p-5 mt-2">
      <h1 class="mb-8 text-xl font-bold">Productos</h1>
      <div class="m-2 flex">
        <a target="_blank" :href="`#`" class="btn-blue mr-2">Productos por capital</a>
        <a target="_blank" :href="`#`" class="btn-blue mr-2">Productos con su costo, precio y ganancia</a>
        <a target="_blank" :href="`#`" class="btn-blue mr-2">Top de productos más vendidos</a>
      </div>
    </div> -->

    <!-- <div class="bg-white p-5 mt-2">
      <h1 class="mb-8 text-xl font-bold">Vendedores</h1>
      <div class="m-2 flex">
        <a target="_blank" :href="`#`" class="btn-blue mr-2">Top de vendedores</a>
        <a target="_blank" :href="`#`" class="btn-blue mr-2">Recaudación de vendedores</a>
        <a target="_blank" :href="`#`" class="btn-blue mr-2">Clientes por vendedor</a>
      </div>
    </div> -->

    <div class="bg-white p-5 mt-2">
      <h1 class="mb-8 text-xl font-bold">Lote de inventario</h1>
      <div class="m-2 flex">
        <a target="_blank" :href="`#`" class="btn-blue mr-2">Historial de entradas de inventario</a>
      </div>
    </div>

    <!-- <div class="bg-white p-5 mt-2">
      <h1 class="mb-8 text-xl font-bold">Gastos</h1>
      <div class="m-2 flex">
        <a target="_blank" :href="`#`" class="btn-blue mr-2">Gastos según categoria</a>
      </div>
    </div> -->

    <div class="bg-white p-5 mt-2">
      <h1 class="mb-8 text-xl font-bold">Cobranzas</h1>
      <div class="m-2 flex">
        <a target="_blank" :href="`#`" class="btn-blue mr-2">Por vendedor</a>
        <a target="_blank" :href="`#`" class="btn-blue mr-2">Cuentas por cobrar</a>
        <a target="_blank" :href="`/reports/pays/expireds`" class="btn-blue mr-2">Analisis de vencimiento</a>
        <a target="_blank" :href="`#`" class="btn-blue mr-2">Ventas por vencer</a>
        <a target="_blank" :href="`/reports/pays/totals/${form.from}/${form.to}`" class="btn-blue mr-2">Pagos recibidos</a>
        <a target="_blank" :href="`/reports/pays/receipts/${form.from}/${form.to}`" class="btn-blue mr-2">Recibos</a>
      </div>
    </div>



    <div class="flex" v-if="role == 'admin' || role == 'storer'">
      <div>
        <h3 class="py-2 text-xl font-bold">Productos por agotarse</h3>
        <div class="bg-white rounded-xl shadow">
          <table class="w-full">
            <thead>
              <tr class="text-left font-bold">
                <th class="pb-4 pt-6 px-6">Código</th>
                <th class="pb-4 pt-6 px-6">Nombre</th>
                <th class="pb-4 pt-6 px-6">Cantidad</th>
              </tr>
            </thead>
              <tr v-for="prod in productsSoldout" :key="prod.id">
                <td class="px-6 py-4 focus:text-indigo-500">{{ prod.code }}</td>
                <td class="px-6 py-4 focus:text-indigo-500">{{ prod.name }}</td>
                <td class="px-6 py-4 focus:text-indigo-500">{{ prod.quantity }}</td>
              </tr>
            <tr v-if="!productsSoldout">
              <td class="px-6 py-4 border-t" colspan="4">No hay productos por agotarse.</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput.vue'
import SelectInput from "@/Shared/SelectInput.vue";

export default {
  components: {
    SelectInput,
    TextInput,
    Head,
  },
  layout: Layout,
  props: {
    order: String,
    deposits: Object,
    vendors: Object,
    clients: Object
  },
  data() {
    return {
      form: this.$inertia.form({
        from: '',
        to: '',
        type: 'pdf',
        modality: '',
        full: false,
        nulled: 0,
        modality: 'simple',
        orderNumber: Math.floor(Math.random() * (59999 - 10) + 10)
      }),
      count: 0
    }
  },
  methods: {
    getRandom() {
        this.form.orderNumber = Math.random() * (59999 - 10) + 10
    },
    generateReport(link = ''){
      return this.form.post(`reports/${link}`, {onSuccess: (data) => {
          this.count = 1
          console.log(data)
        }})
      //window.location.href = `/reports/sales/totals/${this.form.from}/${this.form.to}/${this.form.modality}`
    },
  },
}
</script>
